import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import ofuesiFavicon from './assets/ofuesi-logo.png';

// Set favicon to OFUESI logo at runtime so we don't rely on public folder
const ensureFavicon = (href: string) => {
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.type = 'image/png';
  link.href = href;
};
ensureFavicon(ofuesiFavicon);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.getRegistrations?.().then((registrations) => {
      registrations.forEach((registration) => {
        const scripts = [registration.active, registration.installing, registration.waiting]
          .map((worker) => worker?.scriptURL || "")
          .join(" ");
        if (
          scripts.includes("/hotel-guide-sw.js") ||
          scripts.includes("/ofuesi-documents-sw.js") ||
          scripts.includes("/hotel-guide-route-sw.js")
        ) {
          registration.unregister();
        }
      });
    }).catch(() => {});
  });
}

createRoot(document.getElementById("root")!).render(<App />);
